import styled from "styled-components";

export const DivForm = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  max-width: 730px;
  margin-top: 3rem;
  margin: auto;

  input:-webkit-autofill {
    -webkit-box-shadow: 0 0 0 30px #ffffff inset;
  }

  @media (min-height: 800px) {
    margin-top: 4rem;
  }

  .MuiFormLabel-root.Mui-error {
    color: #757575;
  }
`;

export const TextInfoOne = styled.div`
  font-size: 14px;
  margin: 24px 0px 16px 0px;
  font-weight: bold;

  @media (max-width: 600px) {
    max-width: 324px;
    margin: 24px 37px 16px 0px;
  }
`;

export const DivContainer = styled.div`
  display: grid;
  grid-template-columns: auto auto;
  max-width: 728px;
  gap: 1rem;

  .MuiFormHelperText-contained {
    margin-left: 0px !important;
    margin-right: 0px !important;
    color: #bc0000;
    margin-top: -2px;
  }

  .MuiFormHelperText-root {
    font-size: 1rem !important;
    font: normal normal normal 14px/22px Open Sans !important;
  }

  .MuiFormHelperText-marginDense {
    margin-top: -2px !important;
  }

  @media (max-width: 600px) {
    grid-template-columns: auto;
  }

  .input-AXS {
    margin: 0 0 2em 0;
  }
`;

export const DivButtonContainer = styled.div`
  @media (max-width: 600px) {
    width: 92%;
  }
`;

export const DivOver = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(66, 66, 66, 0.5);
  transition: all 0.3s ease-out;
`;

export const ButtonSend = styled.button`
  margin: 1rem 0.25rem 5rem 0.25rem;
  font-size: 1rem;
  padding: 1em;
  width: 100%;
  background: #6c5af4;
  border: 0;
  border-radius: 8px;
  color: #ffffff;

    &:disabled {
    background: #d3d3d3;
    color: #888;
    cursor: not-allowed;
  }

  @media (max-width: 600px) {
    min-width: 150px;
    margin-inline: 1rem;
  }
`;

export const Title1 = styled.div`
  font-weight: bold;
  font-size: 1.5rem;
  text-align: center;
  color: #212121;
  margin-bottom: 1em;
  @media (max-width: 600px) {
    max-width: 100%;
  }
`;

export const InputLabel = styled.label`
  font-style: normal;
  font-weight: 400;
  font-size: 1rem;
  line-height: 1.25em;
  color: #212121;
`;

export const DivSelect = styled.div`
  margin: 0 0 2em 0;
  height: 3.5rem;
  background: #ffffff;
  border: 1px solid #e0e0e0;
  border-radius: 8px;

  .MuiAutocomplete-root {
    width: 100%;
  }

  .MuiFormControl-root {
  }

  .MuiAutocomplete-input {
    padding: 7.5px 4px 7.5px 5px;
    color: #757575;
  }

  .MuiOutlinedInput-notchedOutline {
    border: none;
    color: #757575;
  }

  .MuiFormLabel-root-MuiInputLabel-root.Mui-focused {
    color: #757575;
  }

  .Mui-focused {
    color: #757575;
  }

  .MuiOutlinedInput-root {
    height: 3.5rem;
    padding-right: 48px;
  }

  .MuiInputLabel-outlined.MuiInputLabel-marginDense {
    transform: translate(1em, 1.25em) scale(1);
    color: #757575;
  }

  .MuiInputLabel-outlined.MuiInputLabel-shrink {
    transform: translate(1em, -0.6em) scale(1);
  }

  .css-i4bv87-MuiSvgIcon-root {
    background-image: none;
  }

  .MuiFormLabel-root {
    font-family: var(--bs-body-font-family);
    font-size: 1rem;
    font-weight: 100;
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
    padding-right: 50px;
  }

  .MuiAutocomplete-hasPopupIcon.MuiAutocomplete-hasClearIcon.css-1xnbq41-MuiAutocomplete-root
    .MuiOutlinedInput-root {
    padding-right: 48px;
  }
`;

export const DivBoxInput = styled.div`
  display: grid;
  grid-template-columns: auto auto auto auto auto auto;
  grid-gap: 0 0.5rem;
  @media (max-width: 600px) {
    grid-template-columns: auto auto auto;
    -webkit-box-pack: justify;
    -webkit-justify-content: space-between;
    -ms-flex-pack: justify;
    justify-content: center;
  }

  .input-AXS {
    margin-bottom: 20px;
  }
  .input-AXS input {
    width: 100%;
  }
`;

export const RadioInputContainer = styled.div`
  margin: 1rem 0;
  opacity: 1;
  grid-row-gap: 15px;
  max-width: 620px;

  .custoBoleto {
    color: #9e9e9e;
    font-weight: 400;
    font-size: 0.7rem;
    margin-left: 0.2em;
    margin-top: 1em;
    font-family: "Open Sans, sans-serif";
  }

  input[type="radio"] {
    appearance: none;
    margin: 0 0.75em;
    width: 1.2em;
    height: 1.2em;
    box-shadow: inset 0 0 0 0.4em white, 0 0 0 0.1em #6c5af4;
    border-radius: 50%;
    transition: 0.2s;
    cursor: pointer;
    vertical-align: bottom;
  }

  input[type="radio"]:disabled {
    cursor: default;
    box-shadow: inset 0 0 0 0.3em white, 0 0 0 0.1em #f1f1f1;
  }

  input[type="radio"]:disabled {
    label {
      color: #f1f1f1 !important;
    }
  }

  input[type="radio"]:disabled:hover {
    box-shadow: inset 0 0 0 0.3em white, 0 0 0 0.1em #f1f1f1;
  }

  input[type="radio"]:disabled:checked {
    cursor: default;
    background: #f1f1f1;
    box-shadow: inset 0 0 0 0.3em white, 0 0 0 0.1em #f1f1f1;
  }

  input[type="radio"]:hover,
  input[type="radio"]:checked {
    box-shadow: inset 0 0 0 0.6em white, 0 0 0 0.1em;
  }

  input[type="radio"]:checked {
    background: #6c5af4;
    box-shadow: inset 0 0 0 0.3em white, 0 0 0 0.1em #6c5af4;
  }

  input[type="radio"]:focus {
    outline: 0;
  }

  @media (max-width: 600px) {
    margin-inline: 1rem;
  }
`;

export const Title2 = styled.p``;

export const ErrorText = styled.p`
  margin-left: 0.25rem;
  color: #bc0000;
  font-size: 14px;
  margin-top: -18px;
  @media (max-width: 600px) {
    margin-inline: 1rem;
  }
`;

export const DivTableDrag = styled.div`
  overflow: hidden;
  label {
    width: 100%;
  }
  @media (max-width: 600px) {
    width: 100%;
    display: block;
  }
`;
